import erc20ABI from '../abis/erc20ABI.js'
import bscABI from '../abis/bscABI.js'

const ethData = {
  testnet: {
    chainId: 11155111,
    chainName: 'Sepolia Testnet',
    nativeCurrency: 'sepETH',
    rpc: [
      'https://ethereum-sepolia.publicnode.com',
      'https://endpoints.omniatech.io/v1/eth/sepolia/public',
      'https://ethereum-sepolia.blockpi.network/v1/rpc/public',
    ],
    explorerUrl: 'https://sepolia.etherscan.io/',
  },
  mainnet: {
    chainId: 1,
    chainName: 'Ethereum Mainnet',
    nativeCurrency: 'ETH',
    rpc: [
      'https://mainnet.infura.io/v3/',
      'https://ethereum.blockpi.network/v1/rpc/public',
      'https://endpoints.omniatech.io/v1/eth/mainnet/public	',
    ],
    explorerUrl: 'https://etherscan.io/',
  },
  chainType: 'evm',
  abi: erc20ABI,
}

const bscData = {
  testnet: {
    chainId: 97,
    chainName: 'BSC Testnet',
    nativeCurrency: 'tBNB',

    rpc: [
      'https://data-seed-prebsc-1-s1.binance.org:8545',
      'https://bsc-testnet.blockpi.network/v1/rpc/public',
      'https://bsc-testnet.publicnode.com',
    ],
    explorerUrl: 'https://testnet.bscscan.com/',
  },
  mainnet: {
    chainId: 56,
    chainName: 'BNB Smart Chain (previously Binance Smart Chain Mainnet)',
    nativeCurrency: 'BNB',
    rpc: [
      'https://bsc-dataseed.binance.org/',
      'https://bsc.blockpi.network/v1/rpc/public',
      'https://endpoints.omniatech.io/v1/bsc/mainnet/pub',
    ],
    explorerUrl: 'https://bscscan.com/',
  },
  chainType: 'evm',
  abi: bscABI,
}

const polygonData = {
  testnet: {
    chainId: 80001,
    chainName: 'Matic(Polygon) Testnet Mumbai',
    nativeCurrency: 'MATIC',
    rpc: [
      'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78',
      'https://polygon-mumbai.blockpi.network/v1/rpc/public',
      'https://endpoints.omniatech.io/v1/matic/mumbai/public',
    ],
    explorerUrl: 'https://mumbai.polygonscan.com/',
  },
  mainnet: {
    chainId: 137,
    chainName: 'Matic(Polygon) Mainnet',
    nativeCurrency: 'MATIC',
    rpc: [
      'https://polygon-mainnet.infura.io',
      'https://polygon.blockpi.network/v1/rpc/public',
      'https://endpoints.omniatech.io/v1/matic/mainnet/public',
    ],
    explorerUrl: 'https://polygonscan.com/',
  },
  chainType: 'evm',
  abi: erc20ABI,
}

const multiversxData = {
  testnet: {
    chainId: 'D',
    chainName: 'Devnet',
    nativeCurrency: 'xEGLD',
    rpc: '',
    explorerUrl: 'https://devnet-explorer.multiversx.com/transactions/',
  },
  mainnet: {
    chainId: '1',
    chainName: 'Mainnet',
    nativeCurrency: 'EGLD',
    rpc: '',
    explorerUrl: 'https://explorer.multiversx.com/transactions/',
  },
  chainType: 'mvx',
  abi: null,
}

export type chainsDataType = typeof networksData

export type networkType = 'testnet' | 'mainnet'

export const networksData = {
  bnb: bscData,
  ethereum: ethData,
  polygon: polygonData,
  multiversx: multiversxData,
}
